export const UPDATE = 'abflags/update';
